import {
  styled,
  InputBase,
  alpha,
  Button,
  TextField,
  IconButton,
  Tooltip,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import React from "react";
import "./secondary_account.css";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const SecAccount = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
    }),
  }));

  return (
    <div className="secondary-account-list">
      <div className="row-1 mt-4">
        <Grid className="sec_grid" container spacing={2}>
          <Grid size={8}>
            <TextField
              className="searchbar"
              label="Search"
              variant="outlined"
              size="small"
              slotProps={{
                input: {
                  endAdornment: (
                    <IconButton type="button" aria-label="search" size="small">
                      <SearchIcon />
                    </IconButton>
                  ),
                },
              }}
            />
          </Grid>
          <Grid size={4}>
            <button className="invite-button">Invite</button>
          </Grid>
        </Grid>
      </div>
      <div className="mb-4">
        <MenuList
          sx={{
            padding: "12px",
          }}
        >
          <MenuItem
            className="mt-2"
            sx={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "10px",
              marginBottom: "10px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
                borderColor: "#b24743",
              },
            }}
          >
            <ListItemIcon>
              <AccountCircleIcon fontSize="large" className="profile-icon" />
            </ListItemIcon>
            <ListItemText>User 1</ListItemText>
            <EditNoteIcon />
            <DeleteOutlineIcon />
          </MenuItem>
          <MenuItem
            className="mt-2"
            sx={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "10px",
              marginBottom: "10px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
                borderColor: "#b24743",
              },
            }}
          >
            <ListItemIcon>
              <AccountCircleIcon fontSize="large" className="profile-icon" />
            </ListItemIcon>
            <ListItemText>User 2</ListItemText>
            <EditNoteIcon />
            <DeleteOutlineIcon />
          </MenuItem>
        </MenuList>
      </div>
    </div>
  );
};

export default SecAccount;
